/*
  Shared wishlist helpers for JS-rendered product cards (Relewise mini-cards),
  which can't render the wishlist-button Liquid snippet. Buttons are wrapped in
  <wishlist-toggle> (assets/wishlist.js), which keeps their active state in
  sync with the wishlist store. Used by relewise.js.
*/
(() => {
  if (window.wishlistHelpers) return;
  let cachedIcon;
  let cachedAriaLabel;

  window.wishlistHelpers = {
    getIcon() {
      if (cachedIcon !== undefined) return cachedIcon;
      const tpl = window.wishlistData?.templates?.button;
      if (!tpl) return '';
      const holder = document.createElement('div');
      holder.innerHTML = tpl;
      const btn = holder.querySelector('[data-button-wishlist]');
      cachedIcon = btn ? btn.innerHTML.trim() : '';
      cachedAriaLabel = btn?.getAttribute('aria-label') || 'Add to wishlist';
      return cachedIcon;
    },

    contains(handle) {
      try {
        const state = JSON.parse(localStorage.getItem('__wishlist-app__wishlist'));
        return (state?.lists || []).some((list) =>
          (list.items || []).some((item) => item.handle === handle)
        );
      } catch (e) {
        return false;
      }
    },

    buildButton(handle, asElement = false) {
      const icon = this.getIcon();
      if (!icon || !handle) return asElement ? null : '';
      const activeClass = this.contains(handle) ? ' button-wishlist--active' : '';
      
      if (asElement) {
        const wrapper = document.createElement('wishlist-toggle');
        wrapper.style.display = 'contents';
        wrapper.innerHTML = `<div class="wish__ext" style="height:0"><button type="button" class="button-wishlist button-grid${activeClass}" data-button-wishlist aria-label="${cachedAriaLabel}">${icon}</button></div>`;
        wrapper.querySelector('button').dataset.productHandle = handle;
        return wrapper;
      }
      
      const escapeHtml = (s) => {
        const d = document.createElement('div');
        d.textContent = String(s);
        return d.innerHTML.replace(/"/g, '&quot;');
      };
      
      return `<wishlist-toggle style="display:contents"><div class="wish__ext" style="height:0">
        <button type="button" class="button-wishlist button-grid${activeClass}" data-button-wishlist aria-label="${escapeHtml(cachedAriaLabel)}" data-product-handle="${escapeHtml(handle)}">
          ${icon}
        </button>
      </div></wishlist-toggle>`;
    }
  };
})();
